import { render, staticRenderFns } from "./defaultInfo.vue?vue&type=template&id=3d0b31d2&scoped=true"
import script from "./defaultInfo.vue?vue&type=script&lang=js"
export * from "./defaultInfo.vue?vue&type=script&lang=js"
import style0 from "./defaultInfo.vue?vue&type=style&index=0&id=3d0b31d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b31d2",
  null
  
)

export default component.exports